// @flow

import * as React from "react"
import type {BabyAnswer, Survey, Dispatch} from "../../types"
import {isEqual, debounce} from "lodash"
import {connect} from "react-redux"
import {withTranslation} from "react-i18next"
import {updateSurvey} from "../../actions/baby"
import IntakeSurveyQuestion from "./survey-question"

type Props = {
  survey: Survey,
  dispatch: Dispatch,
  babyToken: string,
  isSaving: boolean,
  t: any,
}

type SurveyEdit = any

type State = {
  survey: SurveyEdit,
}

class IntakeSurveyQuestions extends React.Component<Props, State> {
  handleQuestionUpdate: (
    SyntheticInputEvent<HTMLInputElement | HTMLSelectElement>,
    question: BabyAnswer,
    value: any
  ) => void
  save: () => void

  constructor(props: Props) {
    super(props)
    this.state = {
      survey: prepareSurveyFromProps(props.survey),
    }
    this.handleQuestionUpdate = this.handleQuestionUpdate.bind(this)
    this.save = debounce(this.save.bind(this), 2000)
  }

  componentDidUpdate(prevProps: Props) {
    const {survey} = this.props
    if (!isEqual(prevProps.survey, survey)) {
      this.setState({
        survey: this.createSurveyEdit(survey),
      })
    }
  }

  createSurveyEdit(survey: Survey): SurveyEdit {
    return [...survey]
  }

  handleQuestionUpdate(
    e: SyntheticInputEvent<HTMLInputElement | HTMLSelectElement>,
    question: BabyAnswer
  ) {
    const target = e.target
    const property = e.target.name
    let value = ""
    if (target.type == "checkbox") {
      value = target.checked ? "true" : "false"
    } else {
      value = target.value
    }

    this.setState(
      {
        survey: this.state.survey.map((q) => {
          if (q.babyQuestionId === question.babyQuestionId) {
            return {
              ...q,
              [property]: value,
            }
          }
          return {...q}
        }),
      },
      () => this.save()
    )
  }

  save() {
    const {dispatch, babyToken} = this.props
    const edits = this.state.survey
    const empties = false // edits.filter(q => q.answer == '').length > 0
    if (empties) {
      alert("Please answer all questions")
    } else {
      if (edits) {
        dispatch(updateSurvey(babyToken, edits))
      }
    }
  }

  render() {
    const {isSaving} = this.props
    return (
      <ul className="intake-survey-questions pb-4 mb-4">
        {this.state.survey.map((q) => (
          <IntakeSurveyQuestion
            key={`isq-${q.babyQuestionId}`}
            isSaving={isSaving}
            question={q}
            onQuestionUpdate={this.handleQuestionUpdate}
          />
        ))}
      </ul>
    )
  }
}

export default withTranslation()(connect()(IntakeSurveyQuestions))

// TODO move
const prepareSurveyFromProps = (survey: Survey): any =>
  survey.map((q) => {
    if (q.answer === "") {
      if (q.type === "boolean") {
        return {
          ...q,
          answer: "false",
        }
      }
    }
    return q
  })
